import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { GALLERY_SLIDER_IMAGE_LIST } from "../../utils/defaults";
import Icons from "../common/components/Icons";
import BlueTag from "../common/ui/BlueTag";
import Heading from "../common/ui/Heading";
import FlipCard from "../common/components/FlipCard";
const ExploreMoments = ({ imgList = GALLERY_SLIDER_IMAGE_LIST }) => {
  return (
    <div
      id="gallery"
      className="py-12 sm:py-14 md:py-20 bg-custom-blue-v2 relative z-10"
    >
      <div className="text-center">
        <BlueTag variant="white" center>
          GALLERY OF HONOUR
        </BlueTag>
      </div>
      <Heading
        variant="white"
        className="text-center mt-1.5 mb-10 md:mb-[60px]"
      >
        Explore the Moments
      </Heading>

      <div className="mx-auto">
        <Swiper
          modules={[Navigation]}
          centeredSlidesBounds
          centeredSlides
          slidesPerView={1.29}
          spaceBetween={7}
          loop
          grabCursor
          navigation={{
            nextEl: "#gallery-next",
            prevEl: "#gallery-prev",
          }}
          breakpoints={{
            400: { slidesPerView: 1.7, spaceBetween: 7 },
            640: { slidesPerView: 1.5, spaceBetween: 0 },
            768: { slidesPerView: 1.33, spaceBetween: 0 },
            835: { slidesPerView: 1.63, spaceBetween: 0 },
            1024: { slidesPerView: 2.27, spaceBetween: 0 },
            1536: { slidesPerView: 3.27, spaceBetween: 0 },
            1940: { slidesPerView: 4.27, spaceBetween: 0 },
          }}
        >
          {imgList.length > 0 &&
            imgList.map((src, index) => (
              <SwiperSlide key={index}>
                <div className="w-full h-[235px] sm:h-[350px] md:h-[506px] transition-transform duration-300 relative">
                  <div className="w-full absolute top-0 left-0 h-full rounded-md overflow-hidden">
                    <FlipCard imageUrl={src}></FlipCard>
                  </div>
                  <img
                    src={src}
                    alt="slider-image"
                    className="w-full h-full max-w-[624px] object-top object-cover rounded-xl opacity-0 pointer-events-none"
                  />
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
        <div className="flex justify-center items-center gap-4 mt-[30px] md:mt-[52px]">
          <div
            id="gallery-prev"
            className="w-[26px] h-[26px] sm:w-14 sm:h-14 flex group cursor-pointer justify-center items-center rounded-full bg-custom-blue-v2 hover:bg-white border border-solid border-white"
          >
            <Icons className="size-3 sm:size-6" icon="gallery-left-arrow" />
          </div>
          <div
            id="gallery-next"
            className="w-[26px] h-[26px] sm:w-14 sm:h-14 flex group cursor-pointer justify-center items-center rounded-full bg-custom-blue-v2 hover:bg-white border border-solid border-white"
          >
            <Icons className="size-3 sm:size-6" icon="gallery-right-arrow" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreMoments;
